export const DEFAULT_SIZE = 'default';

export const BUTTON_SIZE = {
  MEDIUM: 'medium',
  BIG: 'big'
};
